import { useEffect, useState } from "react";

export const useNavHeight = (selector = ".navbar") => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const getHeight = () => {
      const nav = document.querySelector(selector);
      if (nav) {
        setHeight(nav.offsetHeight);
      }
    };

    getHeight(); // initial

    // update on resize
    window.addEventListener("resize", getHeight);

    return () => {
      window.removeEventListener("resize", getHeight);
    };
  }, [selector]);

  return height;
};
